import React from 'react';

import { TotalItemsLabel } from '@/components/index.ts';
import { TableHeaderLayout } from '@/layouts';

export const OfferHeader = ({
  count,
  selectedRows,
  onDelete,
  onDeactivate,
  onActivate,
  onDuplicate,
  onCancel,
}: {
  count: number;
  selectedRows: number[];
  onDelete: () => void;
  onDuplicate: () => void;
  onDeactivate: () => void;
  onActivate: () => void;
  onCancel: () => void;
}) => (
  <TableHeaderLayout
    selectedRows={selectedRows}
    onDeactivate={onDeactivate}
    onActivate={onActivate}
    onDuplicate={onDuplicate}
    onCancel={onCancel}
    onDelete={onDelete}
    actions={{ onDelete: true, onDuplicate: true, onDeactivate: true, onActivate: true }}
  >
    <TotalItemsLabel count={count} />
  </TableHeaderLayout>
);
